module.exports = __webpack_public_path__ + "media/images/icons/flat-color-square-instagram-7717a81ea7773ba41b5ae8fe67bf9d1e.png";